<template>
  <div>
    <!--&lt;!&ndash; ページヘッダー &ndash;&gt;-->
    <!--<div class="container-fluid page-head-wrap">-->
      <!--<div class="container page-head">-->
        <!--<h3 class="h4 text-center">-->
          <!--<router-link :to="{ name: 'top', params: {} }">-->
            <!--<i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>-->
          <!--</router-link>-->
          <!--<b><trans-text i18nKey="ui[13][1]"/></b>-->
        <!--</h3>-->
      <!--</div>-->

    <!--</div>-->

    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <router-link :to="{ name: 'top', params: {} }">
            <i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>
          </router-link>
          <b><trans-text i18nKey="ui[13][1]"/></b>
        </h3>
      </div>
    </div>
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <p class=" questionnaire-subhead mb-0 text-center"><trans-text i18nKey="ui[13][6]"/></p>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">

          <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
            <b><trans-text :i18nKey="apiErrorI18nKey"/></b>
          </div>
          <!-- 入力フォーム -->
          <page-form @tryForm="tryForm"></page-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from 'page/partials/PasswordRemindForm/PageForm.vue'

  export default {
    name:"PasswordRemindFrom",
    components: {
      PageForm,
    },
    data () {
      return {
        apiErrorI18nKey:null
      }
    },
    created(){
    },
    methods:{
      tryForm(inputs){
        app.make("axios").post(`v1/password-remind`,inputs)
          .then(({data}) =>{
            this.$router.push({name:"password-remind-request"})
          })
          .catch(error => {
              console.log("b",error)
            this.apiErrorI18nKey = "error[13][10]"
          })
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PasswordRemindFrom.vue?da667846